import { _footerEn as footer } from './footer/footer';
import { _cookiesEn as cookie } from './cookies/cookies';
import { _notificationsEn as notifications } from './notifications/notifications';
import { _alertsEn as alerts } from './alerts/alerts';
import { _sessionEn as session } from './session/session';
import { _rightMenuEn as rightMenu } from './menus/rightMenu';
import { _gamesTableEn as gamesTable } from './tables/gamesTable';
import { _modalsEn as modals } from './modals/modals';
import { _homePageEn as gameHomePage } from './gameHomePage/home';
import { _configEn as config } from './configuration/config';
import { _defaultEn as defaults } from './default';
import { _authEn as auth } from './configuration/authorizations';
import { _assignmentsEn as assignments } from './assignments/assignments';
import { _planningEn as planning } from './assignments/planning';
import { _sgaEn as sga } from './sga/sga';
import { _sgoEn as sgo } from './sgo/sgo';
import { _sigEn as sig } from './sig/sig';
import { _bipEn as bip } from './bip/bip';
import { _radioEn as radio } from './radio/radio';
import { _ticketEn as ticket } from './assignments/ticket';
import { _shopEn as shop } from './shop/shop';

export const en = {
    title: 'Special Alerts',
    module: 'mod role play',
    chooseLangage: 'Choose language',
    account: 'account',
    disconnect: 'Disconnect',
    refresh: 'Refresh',
    loading: 'Loading',
    load: 'Load',
    to: 'to',
    send: 'Send',
    allRights: 'All rights reserved',
    create: 'Create',
    game: 'Game',
    changeThemeDark: 'Use the dark theme',
    changeThemeLight: 'Use the light theme',
    yes: 'Yes',
    no: 'No',
    delete: 'Delete',
    cancel: 'Cancel',
    validate: 'Validate',
    close: 'Close',

    defaults,
    footer,
    cookie,
    notifications,
    alerts,
    session,
    rightMenu,
    gamesTable,
    modals,
    gameHomePage,
    config,
    auth,
    assignments,
    planning,
    sga,
    sgo,
    sig,
    bip,
    radio,
    ticket,
    shop,
};
